import { CssBaseline } from '@mui/material'

import { ThemeProvider } from '@mui/material/styles'
import { StyledEngineProvider } from '@mui/system'

import ErrorBoundary from './components/ErrorBoundary'

import { getCreateThemeWithRouterComponents } from './styles/getCreateTheme'
import { inputGlobalStyles } from './styles/globalStyles'


export function ThemeProviderWrapper({ children }) {
  const themeObject = getCreateThemeWithRouterComponents()
  return (
    <ErrorBoundary errorType="theme">
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themeObject}>
          <CssBaseline />
          {inputGlobalStyles(themeObject)}
          {children}
        </ThemeProvider>
      </StyledEngineProvider>
    </ErrorBoundary>
  )
}
